import { render } from "./pasdeh.vue?vue&type=template&id=c4bef2c6&scoped=true"
import script from "./pasdeh.vue?vue&type=script&lang=js"
export * from "./pasdeh.vue?vue&type=script&lang=js"

import "./pasdeh.vue?vue&type=style&index=0&id=c4bef2c6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/smt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4bef2c6"]])

export default __exports__